<script>

import Swal from "sweetalert2";
import moment from "moment/moment";

export default {
  setup() {
    return { };
  },
  components: {

  },
  props: {
    usuariosList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  mounted() {
    // console.log('mounted usuarios-table_0')
    // console.log(this.updating)
  },
  methods: {
    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case true:
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.$router.push(`/usuario/detalhe/${idData}`);

    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/usuario/editar/${idData}`)
    },

    deletar(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},

    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>
        <th class="align-middle">ID</th>
        <th class="align-middle">Foto</th>
        <th class="align-middle">Nome</th>
        <th class="align-middle">Email</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Atividade</th>
        <th class="align-middle">Estado</th>
        <th class="align-middle">Tipo</th>
        <th class="align-middle">Último Login</th>
        <th class="align-middle">Último Pedido</th>
        <th class="align-middle text-end">Valor</th>
        <th class="align-middle text-center">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in usuariosList" :key="data.id">

        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="detalhes(data.id)">
            #{{ data.id }}
          </a>
        </td>
        <td>
          <div v-if="!data.image" class="avatar-xs">

            <span class="avatar-title rounded-circle">{{data.name.substring(0, 3)}}</span>
          </div>
          <div v-if="data.image">
            <img class="rounded-circle avatar-xs" :src="`${data.image}`" alt />
          </div>
        </td>
        <td>{{ data.name }} </td>
        <td>{{ data.email }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === true ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>
        <td>
          <div>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[0]}}</a>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[1]}}</a>
            <a
                href="javascript: void(0);"
                class="badge badge-soft-primary font-size-11 m-1"
            >{{data.tags[2]}}</a>
          </div>
        </td>
        <td> {{ data.estado }}</td>
        <td> {{ data.tipo }}</td>
        <td>{{ data.last_login != null ? formatDateTime(data.last_login) : '' }} </td>
        <td>{{ data.date }} </td>
        <td class="text-end">{{ data.total }} </td>


        <td>
          <div class="button-items">

            <b-button variant="outline-success" @click="detalhes(data.id)">
              <i class="mdi mdi-eye d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-warning" @click="editar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-danger" @click="deletar(data.id)" :disabled="data.email === 'admin@admin.com.br'">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>

          </div>
        </td>


      </tr>
      </tbody>
    </table>


  </div>

</template>
